import React from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { theme } from 'theme'

export interface ActionTextProps {
    actionTitle: string
    url: string
    dataTestId?: string
}

export const ActionTextCell = (params: GridRenderCellParams): JSX.Element => {
    const { dataTestId } = params.value
    return (
        <RouterLink
            to={params.value.url}
            style={{
                color: theme.newColors.primary300,
                width: '165px',
                wordBreak: 'break-all',
                lineHeight: 1,
                fontSize: theme.newFontSizes.m,
                whiteSpace: 'normal',
            }}
        >
            <b data-testid={dataTestId}>{params.value.actionTitle}</b>
        </RouterLink>
    )
}
